/** 认证接口。 */
import { http } from '@/utils/request'
import type { ApiMessage } from '@/types/common'
import type { LoginPayload, TokenResponse, User } from '@/types/user'

export function login(payload: LoginPayload): Promise<TokenResponse> {
  return http.post<TokenResponse>('/auth/login', payload)
}

export function logout(): Promise<ApiMessage> {
  return http.post<ApiMessage>('/auth/logout')
}

export function getMe(): Promise<User> {
  return http.get<User>('/auth/me')
}
